import React from "react";
import { DISCORD_SERVER_INVITE_URL } from "constants/docs";
import { RiDiscordLine } from "react-icons/ri";
import { COLORS } from "utils/styles";

const DEFAULT_COPY = "Join us on Discord";

const DiscordLink = ({ copy = DEFAULT_COPY }) => (
  <a target="_blank" className="link" href={DISCORD_SERVER_INVITE_URL}>
    <div className="flex flex-row pt1 pointer link__decoration--hover">
      <div style={{ marginBottom: -2 }}>
        <RiDiscordLine size={18} color={COLORS.blue} />
      </div>
      <div style={{ paddingLeft: 2 }} className="f6 fw6 color-primary">
        {copy}
      </div>
    </div>
  </a>
);

export default DiscordLink;
